import React from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';

const dialogGlassStyle = {
  background: "rgba(0, 0, 0, 0.85)",
  backdropFilter: "blur(15px)",
  borderRadius: "16px",
  boxShadow: "0 4px 30px rgba(0, 0, 0, 0.2)",
};

const VideoPlayerDialog = ({ open, onClose, video }) => {
  if (!video) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: dialogGlassStyle }}
    >
      <DialogContent sx={{ p: 0, position: "relative", aspectRatio: "16/9" }}>
        <IconButton
          aria-label="close player"
          onClick={onClose}
          sx={{
            position: "absolute", top: 8, right: 8,
            color: "white", zIndex: 1,
            background: "rgba(0,0,0,0.5)",
            "&:hover": { background: "rgba(0,0,0,0.7)" },
          }}
        >
          <Close />
        </IconButton>
        <iframe
          width="100%"
          height="100%"
          src={`https://www.youtube.com/embed/${video.videoId}?autoplay=1&rel=0`}
          title={video.title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{ borderRadius: "16px" }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default VideoPlayerDialog;